// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-statistics-content {\n  padding-top: 24px;\n}\n", ""]);
// Exports
module.exports = exports;
